__webpack_require__.p = "https://bmidxbswitzerlandfrplpreprod.netlify.app/";